export const VERSION_RELEASE_LOGIN_WITH_SHOPEE_ANDROID = '1.2.9';
export const VERSION_RELEASE_LOGIN_WITH_SHOPEE_IOS = '1.2.7';
export const VERSION_RELEASE_LOGIN_WITH_3P_IOS = '1.4.6';
export const VERSION_RELEASE_LOGIN_WITH_3P_ANDROID = '1.4.8';
export const VERSION_RELEASE_QUICK_LOGIN_ANDROID = '1.5.1';
export const VERSION_RELEASE_QUICK_LOGIN_IOS = '1.4.9';
